export default "__VITE_ASSET__C0P4lHnM__"